import React, { Component } from 'react';
import { connect } from "react-redux";
import axios from "axios";
import moment from "moment";
import { Trans } from 'react-i18next';
import Select from 'react-select';

import { setBookingsDb, setProfileDb } from '../../../Actions/dataActions';
import { constants } from '../../../Helpers/Constants';
import { receiveTime, reverseReceiveTime } from '../../../Helpers/ReceiveTimeInArray';
import VehicleCell from "../../Pages/Stakeholder/Vehicle/VehicleCell";
import ProfileCell from "../../Pages/Stakeholder/User/ProfileCell";
import DatePicker from '../DatePicker.jsx';
import LabelledOutline from '../LabelledOutline';
import { getTimeZoneAbbreviation } from '../../../Helpers/getTimeZoneAbbreviation';

import { CreateBookingActionButtons } from './CreateBookingActionButtons';
import Button from '../DesignSystem/Button';
import colours from '../DesignSystem/Colours';

class NewBookingPullout extends Component {
    constructor(props) {
        super(props);

        this.init = this.init.bind(this);
        this.submitNew = this.submitNew.bind(this);
        this.selectTime = this.selectTime.bind(this);
        this.selectUsage = this.selectUsage.bind(this);
        this.selectProfile = this.selectProfile.bind(this);
        this.updateForm = this.updateForm.bind(this);
        this.selectStartDate = this.selectStartDate.bind(this);
        this.selectEndDate = this.selectEndDate.bind(this);
        this.renderUser = this.renderUser.bind(this);
        this.renderProfileOption = this.renderProfileOption.bind(this);
        this.fetchUserList = this.fetchUserList.bind(this);
        this.getProfileOption = this.getProfileOption.bind(this);

        this.state = {
            booking_form: {},
            pickup_times: [],
            dropoff_times: [],
            start_date: null,
            end_date: null,
            vehicle: {},
            loading: true,
            profiles_list: [],
            booking_profile_type: null,
            booking_profile_selected: null,
            booking_vehicle_usage: null,
        };
    }

    componentDidMount() {
        this.init();
    }

    componentDidUpdate(prevProps) {
        if ((prevProps && prevProps.booking !== this.props.booking) || !prevProps) {
            this.init();
        }
    }

    init() {
        this.loadPickupTimes(moment(this.props.booking.start).format('YYYY-MM-DD'));
        this.loadDropoffTimes(moment(this.props.booking.end).format('YYYY-MM-DD'));

        const booking_form = {}
        // let pickup_time = receiveTime(moment(this.props.booking.start).format("h:mmA"));
        // let dropoff_time = receiveTime(moment(this.props.booking.end).format("h:mmA"));

        booking_form['vehicle_id'] = this.props.booking.V_ID
        booking_form['start_date'] = moment(this.props.booking.start).format('YYYY-MM-DD')
        booking_form['end_date'] = moment(this.props.booking.end).format('YYYY-MM-DD')
        // booking_form['pick_up_time'] = reverseReceiveTime(pickup_time) !== '12:00 am' ? pickup_time : null
        // booking_form['drop_off_time'] = reverseReceiveTime(dropoff_time) !== '12:00 am' ? dropoff_time : null
        booking_form['pick_up_time'] = null
        booking_form['drop_off_time'] = null
        // booking_form['vehicle_usage'] = this.props.booking.Usage_Type
        // booking_form['service_usage'] = this.props.booking.Vehicle_Usage
        booking_form['notes'] = this.props.booking.Special_Requests

        this.setState({
            booking_form: booking_form,
            booking_profile_selected: null,
            booking_profile_type: null,
            booking_vehicle_usage: null
        });

        var self = this;
        axios.get('/ajax/vehicle/' + this.props.booking.V_ID)
            .then((res) => {
                self.setState({
                    vehicle: res.data.vehicle,
                    loading: false
                });
                this.fetchUserList(res.data.vehicle);
            });
    }

    fetchUserList(vehicle) {
        var self = this;

        axios({
            method: 'post',
            url: ('/ajax/customers_list/simple/' + vehicle.V_ID),
            data: {
                sh: vehicle.SH_ID,
                vmh: vehicle.VMH_ID,
                sort_direction: "asc",
                sort_filter: "name"
            }
        })
            .then(function (response) {
                self.setState({
                    profiles_list: response?.data.customers
                })
                self.props.dispatch(setProfileDb(response?.data.customers, self.props.data.profile_db));
            })
            .catch(function (error) {
                if (error.response && error.response?.status == 401) {
                    showStatusMsg(error.response?.data.error);
                } else if (error.response && error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            });
    }

    submitNew(bookingBody, setLoadingCreate, callCreateBookingGraphQL) {
        var self = this;

        axios.post('/ajax/booking', bookingBody)
            .then(function (response) {
                //Update the booking
                var booking_db = self.props.data.bookings_db
                if (self.props.booking.BOOK_ID in booking_db) {
                    booking_db[self.props.booking.BOOK_ID]['Start_Date'] = self.state.booking_form['start_date']
                    booking_db[self.props.booking.BOOK_ID]['End_Date'] = self.state.booking_form['end_date']
                    booking_db[self.props.booking.BOOK_ID]['Release_Time'] = moment(reverseReceiveTime(self.state.booking_form['pick_up_time'] - 1), "h:mmA").format("HH:mm:ss")
                    booking_db[self.props.booking.BOOK_ID]['Return_Time'] = moment(reverseReceiveTime(self.state.booking_form['drop_off_time'] - 1), "h:mmA").format("HH:mm:ss")
                    booking_db[self.props.booking.BOOK_ID]['Usage_Type'] = self.state.booking_form['vehicle_usage']
                    booking_db[self.props.booking.BOOK_ID]['Special_Requests'] = self.state.booking_form['notes']
                }

                self.props.dispatch(setBookingsDb([], booking_db));

                var current_booking = self.props.stakeholder.current_booking

                current_booking['Start_Date'] = self.state.booking_form['start_date']
                current_booking['End_Date'] = self.state.booking_form['end_date']
                current_booking['Release_Time'] = moment(reverseReceiveTime(self.state.booking_form['pick_up_time']), "h:mmA").format("HH:mm:ss")
                current_booking['Return_Time'] = moment(reverseReceiveTime(self.state.booking_form['drop_off_time']), "h:mmA").format("HH:mm:ss")
                current_booking['Usage_Type'] = self.state.booking_form['vehicle_usage']
                current_booking['Special_Requests'] = self.state.booking_form['notes']

                // if (self.props.booking && self.props.booking.loadData)
                //     self.props.booking.loadData();
                // if (self.props.booking && self.props.booking.onAdd) {
                //     self.props.booking.onAdd(Object.assign(self.props.booking, response?.data.booking));
                // }

                // [not in use due to queue data sync implementation]
                // this is here because we need the legacy API created booking id => sourceBookingId
                // callCreateBookingGraphQL({ ...response?.data.booking, ...current_booking });

                showStatusMsg('Booking created successfully', 'success');
                window.location.reload();
            })
            .catch(function (error) {
                setLoadingCreate(false);

                if (error.response?.status == 401) {
                    showStatusMsg(error.response?.data.error);
                } else if (error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
    }

    selectStartDate(event) {
        var booking_form = this.state.booking_form

        booking_form['start_date'] = moment(event.target.value).format("YYYY-MM-DD");
        booking_form['pick_up_time'] = null

        this.setState({
            booking_form: booking_form,
            start_date: event.target.value
        })

        this.loadPickupTimes(event.target.value)
    }

    selectEndDate(event) {
        var booking_form = this.state.booking_form

        booking_form['end_date'] = moment(event.target.value).format("YYYY-MM-DD");
        booking_form['drop_off_time'] = null

        this.setState({
            booking_form: booking_form,
            end_date: event.target.value
        })

        this.loadDropoffTimes(event.target.value);
    }

    loadPickupTimes(date) {
        var self = this;

        axios.post('/ajax/vehicle/' + this.props.booking.V_ID + "/options", {
            'date': date,
            'type': 'pickup',
            'booking_id': this.props.booking.BOOK_ID
        })
            .then(function (response) {
                const { data } = response;
                if (data?.length === 1 && data[0]?.option === '12:00 am') {
                    self.setState({ pickup_times: [] });
                    return;
                };

                self.setState({ pickup_times: data });
            })
    }

    loadDropoffTimes(date) {
        var self = this;
        axios.post('/ajax/vehicle/' + this.props.booking.V_ID + "/options", {
            'date': date,
            'type': 'dropoff',
            'booking_id': this.props.booking.BOOK_ID
        })
            .then(function (response) {
                const { data } = response;
                if (data?.length === 1 && data[0]?.option === '12:00 am') {
                    self.setState({ dropoff_times: [] });
                    return;
                };

                self.setState({ dropoff_times: data });
            })
    }

    selectTime(event, type) {
        var booking_form = this.state.booking_form
        if (type === "pickup") {
            booking_form["pick_up_time"] = event.value
        } else if (type === "dropoff") {
            booking_form["drop_off_time"] = event.value
        }

        this.setState({
            booking_form: booking_form
        })
    }

    selectUsage(event) {
        var booking_form = this.state.booking_form
        if (this.state.booking_profile_type === 'Service') {
            booking_form["service_usage"] = event.value
        } else {
            booking_form["vehicle_usage"] = event.value
        }

        this.setState({
            booking_form: booking_form
        })
    }

    selectProfile(type, profile = null) {
        if (type === "Service") {
            this.setState({
                booking_profile_type: "Service",
                booking_profile_selected: true,
                booking_vehicle_usage: -1,
                booking_form: {
                    ...this.state.booking_form,
                    booking_type: null,
                    vehicle_usage: null,
                    service_usage: null
                }
            })
        } else {
            this.setState({
                booking_profile_type: "Profile",
                booking_profile_selected: profile,
            })
        }
    }

    getProfileOption() {
        let profile = this.state.profiles_list.find((opt) => {
            return opt.ID == this.state.booking_profile_selected;
        })

        if (profile) {
            return {
                label: profile.First_Name + (profile.Last_Name ? (" " + profile.Last_Name) : ""),
                value: profile.ID,
                profile: profile
            }
        } else {
            return null;
        }
    }

    updateForm(event) {
        var name = event.target.name
        var booking_form = this.state.booking_form

        booking_form[name] = event.target.value

        this.setState({
            booking_form: booking_form
        })
    }

    renderUser(profile) {
        if (this.props.booking.Book_Type == constants.booking_type.service) {
            profile.Book_Type = constants.booking_type.service;
        }
        return (
            <LabelledOutline label="User" id="user">
                <div style={{ display: 'flex', flex: 1 }}>
                    <ProfileCell profile={profile} showImage showContact={this.props.booking.Book_Type != constants.booking_type.service} />
                </div>
            </LabelledOutline>
        )
    }

    renderProfileOption(option) {
        var name = option.profile.First_Name
        if (option.profile.Last_Name) {
            name += " " + option.profile.Last_Name
        }

        var original_name = name;
        var long = false;

        if (name.length > 14) {
            name = name.substring(0, 14)
            name += "..."
            long = true;
        }

        return (
            <span className="align-left black">
                {
                    option.profile.Is_User === 1 ?
                        "photo" in option.profile && option.profile.photo && "Link" in option.profile.photo && option.profile.photo.Link !== "" ?
                            <img className="mr-8" src={'https://digitalvms.s3.ca-central-1.amazonaws.com/profile-images/thumbnails/thumbnail_' + option.profile.photo.Link} style={{ width: '34px', height: '34px', padding: '8px 6px', borderRadius: '50%' }} />
                            :
                            <span className="mr-8" style={{ width: '34px', height: '34px', padding: '8px 6px', borderRadius: '50px' }}>
                                <img src="images/UserProfile.png" />
                            </span>
                        :
                        <span className="mr-8" style={{ width: '34px', height: '34px', padding: '8px 6px', borderRadius: '50px' }}>
                            <img src="images/TagProfile.png" />
                        </span>
                }
                <span style={{ verticalAlign: "top" }} data-tip={long ? original_name : null}>
                    {name}
                </span>
                {/*this.getSHVMHBadges(option.profile) */}
            </span>
        )
    }


    render() {

        return (
            <div className="booking_pullout new_booking_pullout">
                <div className="booking_header border-bottom">
                    <div className="card-header-title no-margin float-left" style={{ display: 'flex', flexDirection: 'row' }}>
                        <Trans>New Booking</Trans>
                        <div style={{ marginLeft: 10, verticalAlign: 'top', paddingTop: 0, paddingBottom: 0 }}>
                            {/* <Badge status={this.props.booking.Book_Status} service={this.props.booking.Book_Type == 2} completed={this.props.booking.Returned_On !== null}/> */}
                        </div>
                    </div>
                    <button onClick={this.props.closePullout} type='button' style={{ cursor: "pointer" }} className="float-right">
                        <span aria-hidden='true' style={{ fontSize: "1.8em", lineHeight: 1, display: "block" }}>&times;</span>
                    </button>
                    <div className="clearfix"></div>
                </div>
                <div className="card-section">
                    <div className="row mb-24">
                        <VehicleCell history={this.props.history} match={this.props.match} location={this.props.location} vehicle={this.state.vehicle} noOverlay showType noTooltip />
                        <div className="new_booking_pullout_vehicle-image-container">
                            {!this.state.loading && (this.props.booking.resource?._resource?.extendedProps?.vehicle?.photoUrl || this.props.booking.extendedProps?.vehicle?.photoUrl) ? (
                                <img
                                    style={{ borderRadius: '15px', height: this.state.loading ? '180px' : undefined }}
                                    src={this.props.booking.resource?._resource?.extendedProps?.vehicle?.photoUrl || this.props.booking.extendedProps?.vehicle?.photoUrl}
                                />
                            ) : (
                                <img
                                    style={{ borderRadius: '15px', height: this.state.loading ? '180px' : undefined }}
                                    src={this.state.loading ?
                                        '' : this.state.vehicle && this.state.vehicle.Photos ?
                                            'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/' + this.state.vehicle.Photos
                                            : this.props.data.vehicle_db[this.props.booking?.V_ID]?.Photos ?
                                                'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/' + this.props.data.vehicle_db[this.props.booking?.V_ID]?.Photos
                                                : this.props.settings.images.vehicle_placeholder_square.includes("images/") ?
                                                    this.props.settings.images.vehicle_placeholder_square
                                                    : "images/" + this.props.settings.images.vehicle_placeholder_square}
                                />
                            )}
                        </div>
                    </div>
                    <div className="row mb-8">
                        {
                            this.state.vehicle.has_booking === 1
                                && this.state.vehicle.has_servicing_only != 1 ?
                                <Select
                                    options={
                                        this.state.profiles_list.map((profile) => {
                                            return (
                                                {
                                                    label: profile.First_Name + (profile.Last_Name ? (" " + profile.Last_Name) : ""),
                                                    value: profile.ID,
                                                    profile: profile
                                                }
                                            )
                                        })
                                    }
                                    value={this.getProfileOption()}
                                    formatOptionLabel={this.renderProfileOption}
                                    onChange={opt => this.selectProfile("Profile", opt.value)}
                                    style={{ width: "100%" }}
                                    className="react_select_dropdown"
                                    classNamePrefix="react_select"
                                    isDisabled={this.state.booking_profile_type === 'Service'}
                                />
                                :
                                null
                        }
                        <div className="float-left mt-8">
                            <input
                                id="service_checkbox"
                                type="checkbox"
                                onClick={(e) => {
                                    if (e.target.checked)
                                        this.selectProfile("Service")
                                    else
                                        this.setState({
                                            booking_profile_type: null,
                                            booking_profile_selected: null,
                                            booking_vehicle_usage: null,
                                            booking_form: {
                                                ...this.state.booking_form,
                                                booking_type: null,
                                                vehicle_usage: null,
                                                service_usage: null
                                            }
                                        })
                                }} /><label htmlFor="service_checkbox">This is a service booking</label>
                        </div>
                    </div>
                    <div className="row mb-8">
                        {
                            this.state.booking_profile_type === 'Service' ?
                                <label><Trans>Service Usage</Trans>
                                    <input type="text" name="service_usage" placeholder="Service Usage" onChange={this.updateForm} />
                                </label>
                                :
                                <label><Trans>Vehicle Usage</Trans>
                                    <Select
                                        className="react_select_dropdown"
                                        classNamePrefix="react_select"
                                        value={this.state.booking_form.vehicle_usage
                                            ? {
                                                value: this.state.booking_form.vehicle_usage,
                                                label: this.props.settings.vehicle_usage_types[this.state.booking_form.vehicle_usage],
                                            } : null
                                        }
                                        onChange={this.selectUsage}
                                        options={
                                            Object.keys(this.props.settings.vehicle_usage_types).map((key) => {
                                                return (
                                                    { value: key, label: this.props.settings.vehicle_usage_types[key] }
                                                )
                                            })
                                        } />
                                </label>
                        }
                    </div>
                    {/* <h4 className="mb-8"><Trans>Dates & Times</Trans></h4> */}
                    <div className="datesandtimes">
                        <div className="pickup">
                            {/* <div className = "datetime-field"> */}
                            <div className="body medium"><Trans>Pick Up</Trans></div>
                            {/* <DatePicker id="edit-start-date" classname="date-input-field datetime-date date-field datepicker-start no-weekends mb-5" 
                                    name="booking_start_date" placeholder="Select Date ..." disabled={ (this.props.booking.Prep_Status == constants.prep_status.out && this.props.booking.Released_On != null) ? true : false } booking_id={this.props.booking.BOOK_ID} 
                                        value={this.state.start_date ? moment(this.state.start_date).format("MMM DD, YYYY") : ""} updateValue={this.selectStartDate} /> */}
                            <DatePicker id="edit-start-date" classname="datetime-date date-field datepicker-start no-weekends"
                                name="booking_start_date" placeholder="Select Date ..." disabled={false} vehicle_id={this.props.booking.V_ID}
                                value={this.state.booking_form.start_date ? moment(this.state.booking_form.start_date).format("MMM DD, YYYY") : ""} updateValue={this.selectStartDate} />
                            <div className="datetime-time select-eu-vehicle">
                                <Select
                                    className="react_select_dropdown time-select"
                                    classNamePrefix="react_select"
                                    onChange={(e) => this.selectTime(e, "pickup")}
                                    value={{ value: this.state.booking_form.pick_up_time, label: this.state.booking_form.pick_up_time ? reverseReceiveTime(this.state.booking_form.pick_up_time) : '' }}
                                    options={
                                        this.state.pickup_times.map((time) => {
                                            return (
                                                { value: time.value, label: time.option }
                                            )
                                        })
                                    }
                                    isDisabled={(this.props.booking.Prep_Status == constants.prep_status.out && this.props.booking.Released_On != null) ? true : false}
                                />
                            </div>
                            {
                                this.props.booking.Prep_Status == constants.prep_status.out && this.props.booking.Released_On != null ?
                                    <>
                                        <input type="hidden" name="booking_start_date" value={this.state.start_date ? moment(this.state.start_date).format("MMM DD, YYYY") : ""} />
                                        <input type="hidden" name="pick_up_time" value={this.state.booking_form.pick_up_time} />
                                    </>
                                    :
                                    null
                            }
                            <div className="clearfix"></div>
                            {/* </div> */}
                        </div>
                        <div className="arrow">
                            <i className="fas fa-arrow-right overlay_section_details_date_arrow" style={{ fontSize: '32px', color: 'lightgrey', marginTop: 45 }}></i>
                        </div>
                        <div className="dropoff">
                            <div className="body medium"><Trans>Drop Off</Trans></div>
                            {/* <DatePicker key={"datepicker-dropoff-" + this.state.start_date} id="edit-end-date" classname="date-input-field datetime-date date-field datepicker-start no-weekends mb-5" 
                                name="booking_end_date" placeholder="Select Date ..." disabled={false} booking_id={this.props.booking.BOOK_ID} 
                                    value={this.state.end_date ? moment(this.state.end_date).format("MMM DD, YYYY") : ""} updateValue={this.selectEndDate} start_date_id="edit-start-date" /> */}
                            <DatePicker key={"datepicker-dropoff-" + this.state.start_date} id="edit-end-date" classname="datetime-date date-field datepicker-end no-weekends"
                                name="booking_end_date" placeholder="Select Date ..." disabled={false} vehicle_id={this.props.booking.V_ID}
                                value={this.state.booking_form.end_date ? moment(this.state.booking_form.end_date).format("MMM DD, YYYY") : ""} updateValue={this.selectEndDate} start_date_id="edit-start-date" />
                            <div className="datetime-time select-eu-vehicle">
                                <Select
                                    className="react_select_dropdown time-select"
                                    classNamePrefix="react_select"
                                    onChange={(e) => this.selectTime(e, "dropoff")}
                                    value={{ value: this.state.booking_form.drop_off_time, label: this.state.booking_form.drop_off_time ? reverseReceiveTime(this.state.booking_form.drop_off_time) : '' }}
                                    options={
                                        this.state.dropoff_times.map((time) => {
                                            return (
                                                { value: time.value, label: time.option }
                                            )
                                        })
                                    } />
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>


                    <Button
                        secondary
                        leading_ic="Clock"
                        label={`Timezone:  ${getTimeZoneAbbreviation(this.props.booking.vehicleManagementHub.city)} – ${this.props.booking.vehicleManagementHub.city}`}
                        style={{ color: colours.primary.grey01 }}
                    />

                    <div className="row collapse">
                        {/* <h4 className="mb-8"><Trans>Booking Information</Trans></h4> */}
                        <div className="columns large-12 medium-12 small-12 ">
                            <label><Trans>Booking Notes</Trans>
                                <textarea name="notes" defaultValue={this.props.booking.Special_Requests} onChange={this.updateForm} />
                            </label>
                        </div>
                    </div>
                </div>

                <CreateBookingActionButtons
                    closePullout={this.props.closePullout}
                    legacyApiCreateBooking={this.submitNew}
                    bookingForm={this.state.booking_form}
                    vehicleId={this.props.booking.V_ID}
                    profilesList={this.state.profiles_list}
                    profileSelected={this.state.booking_profile_selected}
                    bookingType={this.state.booking_profile_type}
                    settings={this.props.settings}
                    calendarBooking={this.props.booking}
                    loggedInUser={this.props.userSession.user}
                    dispatch={this.props.dispatch}
                />
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    settings: store.settings,
    stakeholder: store.stakeholder
});

export default connect(mapStateToProps)(NewBookingPullout);